// Create a new file: src/app/services/theme.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private currentTheme = new BehaviorSubject<string>('light');
  public currentTheme$ = this.currentTheme.asObservable();

  constructor() {
    // Check for saved theme in localStorage
    const savedTheme = localStorage.getItem('selectedtheme') || 'light';
    this.setTheme(savedTheme);
  }

  setTheme(theme: string): void {
    this.currentTheme.next(theme);
    
    // Remove existing theme classes
    document.body.classList.remove('light-theme', 'dark-theme');
    
    // Add new theme class
    document.body.classList.add(`${theme}-theme`);
    
    // Update CSS custom properties or link tags for your theme files
    this.loadThemeCSS(theme);
    
    // Save to localStorage
    localStorage.setItem('selectedtheme', theme);
  }

  private loadThemeCSS(theme: string): void {
    // Remove existing theme link
    const existingThemeLink = document.getElementById('theme-css') as HTMLLinkElement;
    if (existingThemeLink) {
      existingThemeLink.remove();
    }

    // Create new theme link
    const themeLink = document.createElement('link');
    themeLink.id = 'theme-css';
    themeLink.rel = 'stylesheet';
    themeLink.type = 'text/css';
    themeLink.href = `assets/shui-${theme}/theme.css`;
    
    document.head.appendChild(themeLink);
  }

  getCurrentTheme(): string {
    return this.currentTheme.value;
  }

  toggleTheme(): void {
    const newTheme = this.currentTheme.value === 'light' ? 'dark' : 'light';
    this.setTheme(newTheme);
  }
}

